export const formUrlEncodedConfig = {
  headers: { "Content-Type": "application/x-www-form-urlencoded" },
};

export function buildRepeatedQueryParam(key, values = []) {
  return values
    .filter((value) => value !== undefined && value !== null && value !== "")
    .map((value) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
}

export function buildQueryString(params = {}) {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
}

export function appendQueryString(path, queryString) {
  return queryString ? `${path}?${queryString}` : path;
}

export function createAbortSignalController(currentController) {
  if (currentController) {
    currentController.abort();
  }

  return new AbortController();
}
